import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams, Link } from 'react-router-dom';
import { useResetPasswordMutation } from '../../app/services/auth';

import {
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  FormHelperText,
  Typography,
  Box,
  Stack,
} from '@mui/material';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Visibility from '@mui/icons-material/Visibility';

import styles from '../ResetPassword/style.module.css';

function SetNewPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [newPassword, setNewPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const [resetPassword] = useResetPasswordMutation();
  const { t } = useTranslation();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');

    if (!token) {
      setError(t('signIn.invalidResetToken'));
      return;
    }

    try {
      const response = await resetPassword({ token, newPassword });
      if (response.error) {
        setError(response.error.data?.message || t('signIn.resetFailed'));
      } else {
        setSuccess(true);
      }
    } catch (err) {
      setError(t('signIn.resetFailed'));
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.container_logo}>
        <Typography variant="h4">Wartungssoftware KMG</Typography>
      </div>
      <div className={styles.container_email}>
        <Box display="flex" flexDirection="column" alignItems="center">
          <Typography variant="h4" fontWeight="bold" mb={2}>
            {t('signIn.setNewPassword')}
          </Typography>
          {success ? (
            <>
              <Typography style={{ marginBottom: '16px', textAlign: 'center', color: 'var(--text-primary)' }}>
                {t('signIn.passwordResetSuccess')}
              </Typography>
              <Link to="/sign-in" className={styles.link}>
                {t('signIn.backLogin')}
              </Link>
            </>
          ) : (
            <Stack component="form" onSubmit={handleSubmit} sx={{ width: '100%' }}>
              <FormControl fullWidth variant="outlined" sx={{ mb: 1 }}>
                <InputLabel htmlFor="new-password" shrink>
                  {t('signIn.newPassword')}
                </InputLabel>
                <OutlinedInput
                  id="new-password"
                  type={showPassword ? 'text' : 'password'}
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  label={t('signIn.newPassword')}
                  notched
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword((prev) => !prev)}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
                <FormHelperText>{t('signIn.passwordRequirements')}</FormHelperText>
              </FormControl>

              <Button
                fullWidth
                variant="contained"
                type="submit"
                color="primary"
                style={{ marginTop: '10px', height: '42px' }}
              >
                {t('signIn.submit')}
              </Button>

              {error && (
                <Typography color="error" style={{ marginTop: '10px', textAlign: 'center' }}>
                  {error}
                </Typography>
              )}
              <Link to="/sign-in" className={styles.link} style={{ marginTop: '12px' }}>
                {t('signIn.backLogin')}
              </Link>
            </Stack>
          )}
        </Box>
      </div>
    </div>
  );
}

export default SetNewPassword;
